/**
 * Wording for a failed email link. Cognito's own messages talk about codes,
 * which the learner never saw.
 */
export const linkErrorMessage = (error: unknown, resendHint: string) => {
  const name = (error as { name?: string })?.name;
  if (name === 'CodeMismatchException' || name === 'ExpiredCodeException') {
    return `This link has expired or was already used. ${resendHint}`;
  }
  if (
    name === 'LimitExceededException' ||
    name === 'TooManyRequestsException'
  ) {
    return 'Too many attempts. Please wait a few minutes and try again.';
  }
  return `We couldn't use this link. ${resendHint}`;
};

/** Opening the confirmation link again after it worked. */
export const isAlreadyConfirmed = (error: unknown) =>
  (error as { name?: string })?.name === 'NotAuthorizedException' &&
  /CONFIRMED/.test((error as { message?: string })?.message ?? '');
